import { renderExerciseCard } from './exercise-card.js';

function favorites() {
  let favorites = localStorage.getItem('favorites');
  let parsedFavorites = favorites ? JSON.parse(favorites) : [];

  const favoritesClearMessage = document.querySelector('.favorites-list-clear');
  const favoritesList = document.querySelector('.favorites-list');
  const favoritesPaginationContainer = document.querySelector('.favorites-pagination-block');

  if (!favoritesList || !favoritesPaginationContainer) {
    return;
  }

  let currentPage = 1;
  const itemsPerPage = 10;

  const renderList = () => {
    if (!parsedFavorites || parsedFavorites.length === 0) {
      favoritesList.innerHTML = '';
      favoritesPaginationContainer.innerHTML = '';
      if (favoritesClearMessage) favoritesClearMessage.style.display = 'block';
      return;
    } else {
      if (favoritesClearMessage) favoritesClearMessage.style.display = 'none';
    }

    let pageData;

    if (window.innerWidth >= 1440) {
      pageData = parsedFavorites;
      favoritesPaginationContainer.innerHTML = '';
    }
    else {
      const totalPages = Math.ceil(parsedFavorites.length / itemsPerPage);

      if (currentPage > totalPages) currentPage = totalPages || 1;

      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      pageData = parsedFavorites.slice(startIndex, endIndex);

      renderPagination(totalPages);
    }

    const layout = pageData.map((favorite) => {
      favorite.isHomePage = false;
      favorite.id = favorite._id;
      return renderExerciseCard(favorite);
    });
    favoritesList.innerHTML = layout.join('');
  };

  const renderPagination = (totalPages) => {
    if (totalPages <= 1) {
      favoritesPaginationContainer.innerHTML = '';
      return;
    }

    let paginationHTML = '';
    for (let i = 1; i <= totalPages; i++) {
      const isActive = i === currentPage ? 'active' : '';
      paginationHTML += `<button class="favorites-pagination-btn ${isActive}" type="button" data-page="${i}">${i}</button>`;
    }
    favoritesPaginationContainer.innerHTML = paginationHTML;
  };

  const handleStorageUpdate = () => {
    const updatedFavorites = localStorage.getItem('favorites');
    parsedFavorites = updatedFavorites ? JSON.parse(updatedFavorites) : [];
    renderList();
  };

  favoritesPaginationContainer.addEventListener('click', (event) => {
    if (event.target.classList.contains('favorites-pagination-btn')) {
      const clickedPage = Number(event.target.dataset.page);
      if (clickedPage !== currentPage) {
        currentPage = clickedPage;
        renderList();
        favoritesList.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });

  favoritesList.addEventListener('click', (event) => {
    const trashIcon = event.target.closest('.exercise-card__trash-icon');

    if (trashIcon) {
      const cardItem = trashIcon.closest('.exercise-card');
      const cardId = cardItem.dataset.id;

      parsedFavorites = parsedFavorites.filter((item) => String(item._id) !== String(cardId));
      localStorage.setItem('favorites', JSON.stringify(parsedFavorites));

      renderList();
    }
  });

  window.addEventListener('resize', renderList);
  window.addEventListener('favorites-updated', handleStorageUpdate);
  window.addEventListener('storage', (event) => {
    if (event.key === 'favorites') {
      handleStorageUpdate();
    }
  });

  renderList();
}

export default favorites;